<template>
  <div class="md-layout md-alignment-top-center">
    <div class="md-layout-item md-medium-size-100 md-size-80">
      <md-card>
        <md-card-header>
          <h2>{{$t('settingsPage.heading')}}:</h2>
          <p v-html="$t('settingsPage.infoText')"></p>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-alignment-top-left">
            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <img
                id="strava-logo"
                src="https://cdn.worldvectorlogo.com/logos/strava-2.svg"
                alt="strava"
              />
            </div>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <h3>Strava:</h3>
              <p>
                {{ $t('settingsPage.description', {serviceTitle:"Strava"}) }}<br />
                <i18n path="settingsPage.privacyInfoText">
                  <template v-slot:privacyLink>
                    <a href="https://www.sports4me.at/datenschutz/" target="_blank"
                      >{{ $t('settingsPage.privacyPolicy') }}</a
                    >
                  </template>
                </i18n>
              </p>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div
                v-if="
                  user &&
                    user.connectionServices &&
                    user.connectionServices.strava
                "
              >
                <md-button
                  @click="getLink('strava', false)"
                  class="md-raised md-warning"
                  >{{$t('settingsPage.disconnect')}}</md-button
                >
              </div>
              <div v-else>
                <md-button
                  @click="getLink('strava', true)"
                  class="md-raised md-success"
                  >{{$t('settingsPage.connect')}}</md-button
                >
              </div>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <img
                id="garmin-logo"
                src="https://cdn.worldvectorlogo.com/logos/garmin-2.svg"
                alt="GARMIN"
              />
            </div>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <h3>Garmin:</h3>
              <p>
                {{ $t('settingsPage.description', {serviceTitle:"Garmin"}) }}<br />
                <i18n path="settingsPage.privacyInfoText">
                  <template v-slot:privacyLink>
                    <a href="https://www.sports4me.at/datenschutz/" target="_blank"
                      >{{ $t('settingsPage.privacyPolicy') }}</a
                    >
                  </template>
                </i18n>
              </p>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div
                v-if="
                  user &&
                    user.connectionServices &&
                    user.connectionServices.garmin
                "
              >
                <md-button
                  @click="garmin('remove')"
                  class="md-raised md-warning"
                  >{{$t('settingsPage.disconnect')}}</md-button
                >
              </div>
              <div v-else>
                <md-button @click="garmin()" class="md-raised md-success"
                  >{{$t('settingsPage.connect')}}</md-button
                >
              </div>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <img
                id="polar-logo"
                src="https://flow.cdn.polar.com/flow/5.228.0/images/flow_logo.svg"
                alt="POLAR"
              />
            </div>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <h3>Polar:</h3>
              <p>
                {{ $t('settingsPage.description', {serviceTitle:"Polar"}) }}<br />
                <i18n path="settingsPage.privacyInfoText">
                  <template v-slot:privacyLink>
                    <a href="https://www.sports4me.at/datenschutz/" target="_blank"
                      >{{ $t('settingsPage.privacyPolicy') }}</a
                    >
                  </template>
                </i18n>
              </p>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div
                v-if="
                  user &&
                    user.connectionServices &&
                    user.connectionServices.polar
                "
              >
                <md-button
                  @click="getLink('polar', false)"
                  class="md-raised md-warning"
                  >{{$t('settingsPage.disconnect')}}</md-button
                >
              </div>
              <div v-else>
                <md-button
                  @click="getLink('polar', true)"
                  class="md-raised md-success"
                  >{{$t('settingsPage.connect')}}</md-button
                >
              </div>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <img
                id="suunto-logo"
                src="https://cdn.worldvectorlogo.com/logos/suunto-2.svg"
                alt="SUUNTO"
              />
            </div>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <h3>Suunto:</h3>
              <p>
                {{ $t('settingsPage.description', {serviceTitle:"Suunto"}) }}<br />
                <i18n path="settingsPage.privacyInfoText">
                  <template v-slot:privacyLink>
                    <a href="https://www.sports4me.at/datenschutz/" target="_blank"
                      >{{ $t('settingsPage.privacyPolicy') }}</a
                    >
                  </template>
                </i18n>
              </p>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div
                v-if="user && user.connectionServices && user.connectionServices.suunto"
              >
                <md-button
                  @click="getLink('suunto', false)"
                  class="md-raised md-warning"
                  >{{$t('settingsPage.disconnect')}}</md-button
                >
              </div>
              <div v-else>
                <md-button
                  @click="getLink('suunto', true)"
                  class="md-raised md-success"
                  >{{$t('settingsPage.connect')}}</md-button
                >
              </div>
            </div>

            <div class="md-layout-item md-size-20 md-xsmall-size-50">
              <img
                id="fitbit-logo"
                src="https://cdn.worldvectorlogo.com/logos/fitbit.svg"
                alt="FITBIT"
              />
            </div>
            <div class="md-layout-item md-size-60 md-xsmall-size-100">
              <h3>Fitbit:</h3>
              <p>
                {{ $t('settingsPage.description', {serviceTitle:"Fitbit"}) }}<br />
                <i18n path="settingsPage.privacyInfoText">
                  <template v-slot:privacyLink>
                    <a href="https://www.sports4me.at/datenschutz/" target="_blank"
                      >{{ $t('settingsPage.privacyPolicy') }}</a
                    >
                  </template>
                </i18n>
              </p>
            </div>
            <div class="md-layout-item md-size-20 md-small-size-100">
              <div
                v-if="user && user.connectionServices && user.connectionServices.fitbit"
              >
                <md-button
                  @click="getLink('fitbit', false)"
                  class="md-raised md-warning"
                  >{{ $t('settingsPage.disconnect') }}</md-button
                >
              </div>
              <div v-else>
                <md-button
                  @click="getLink('fitbit', true)"
                  class="md-raised md-success"
                  >{{$t('settingsPage.connect')}}</md-button
                >
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  methods: {
    getLink(sourceName, connect) {
      if (connect) {
        this.$store
          .dispatch("getAuthorizationLink", {
            sourceName: sourceName,
            returnUrl: location.origin + location.pathname + "#" + sourceName
          })
          .then(res => {
            console.log(res);
            if (res.success && res.authorizationLink) {
              window.location.href = res.authorizationLink;
            } else {
              throw Error("Ein unerwarteter Fehler ist aufgetretten!");
            }
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      } else {
        this.$store
          .dispatch("removeAuthorization", {
            sourceName: sourceName
          })
          .then(() => {
            this.$router.push("/").catch(err => {
              console.log(err);
              throw new Error(`Problem handling something: ${err}.`);
            });
            this.$notify({
              timeout: 5000,
              message:
                "Du bist jetzt von " +
                sourceName.toUpperCase() +
                " abgemeldet!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      }
    },
    strava(assign) {
      if (assign) {
        window.location.href =
          "https://www.strava.com/oauth/authorize?client_id=47786&response_type=code&redirect_uri=https://www.sports4me.at/strava/&approval_prompt=force&scope=activity:read,activity:read_all"; // ,profile:read_all";
      } else {
        this.$store
          .dispatch("strava", false)
          .then(() => {
            this.$router.push("/pages/settings").catch(err => {
              console.log(err);
              throw new Error(`Problem handling something: ${err}.`);
            });
            // Tell user he's registered
            this.$notify({
              timeout: 5000,
              message: "Du bist jetzt von Strava abgemeldet!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      }
    },
    garmin(cmd) {
      if (cmd === "remove") {
        this.$store
          .dispatch("garmin", cmd)
          .then(() => {
            this.$router.push("/").catch(err => {
              console.log(err);
              throw new Error(`Problem handling something: ${err}.`);
            });
            // Tell user he's registered
            this.$notify({
              timeout: 5000,
              message: "Du bist jetzt von Garmin abgemeldet!",
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "error"
            });
          });
      } else {
        this.$store
          .dispatch("getGarminAuthorizationLink", this.user)
          .then(res => {
            if (res.success && res.authorizationLink) {
              window.location.href = res.authorizationLink;
            } else {
              this.$notify({
                timeout: 5000,
                message: "Ein unerwarteter Fehler ist aufgetretten!",
                icon: "add_alert",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "error"
              });
            }
            console.log("getGarminAuthorizationLink", res);
          });
      }
    },
    loadUser() {
      this.$store.dispatch("getUser").then(() => {
        console.log("User loaded");
      });
    }
  },
  mounted() {
    this.loadUser();
  }
};
</script>

<style>
#strava-logo {
  width: 8rem !important;
}
</style>
